<template>
    <div>
        <!-- Start Footer Area  -->
        <footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">
            <div v-if="data.showCta" id="contact" name="contact" class="foot-up">
                <div class="foot-up-wrap center70 clearF">
									<div class="foot-contact">
										<h2>联系我们</h2>
										<div class="contact-items">
											<div>
												<div class="contact-item">
													<div class="contact-item-title">
														紧急联络
													</div>
													<div class="contact-item-content">
														<p>邮箱：service@isafeclub.org</p>
													</div>
												</div>
												<div class="contact-item">
													<div class="contact-item-title">
														办公室
													</div>
													<div class="contact-item-content">
														<p>新加坡（亚太总部）</p>
														<p>苏黎世（欧洲合规事务）</p>
														<p>纽约（北美政策联络）</p>
													</div>
												</div>
											</div>
											<div class="contact-item">
												<div class="contact-item-title">
													社交媒体
												</div>
												<div class="contact-item-content">
													<p>telegram技术讨论群组（会员专属）</p>
													<p>Twitter官方账号每日安全提醒</p>
												</div>

												<div class="foot-legal">
													<div class="foot-legal-wrap">
														<div class="legal-links">
															<a href="#" @click.prevent="openModal('terms')">《服务条款》</a>
															<span class="divider">|</span>
															<a href="#" @click.prevent="openModal('privacy')">《隐私政策》</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
            </div>
        </footer>

        <Copyright v-if="data.showCopyright"/>

        <ScrollTop/>

        <!-- Start Legal Modal -->
        <div v-if="activeModal" class="legal-modal" @click.self="closeModal">
            <div class="legal-modal-inner">
                <div class="legal-modal-head">
                    <h2>{{ activeModal === 'terms' ? '服务条款' : '隐私政策' }}</h2>
                    <button class="legal-modal-close" @click="closeModal">
                        <Icon name="x" size="22"/>
                    </button>
                </div>
                <div class="legal-modal-body">
                    <!-- 服务条款 -->
                    <div v-if="activeModal === 'terms'">
                        <div class="legal-section">
                            <h3>1. 服务主体与协议效力</h3>
                            <p>本网站 https://isafeclub.org 由 Isafeclub LIMITED（以下简称“我方”）全权所有并运营，注册及经营主体合法有效，亚太总部位于新加坡，欧洲合规事务办公室位于苏黎世，北美政策联络办公室位于纽约。</p>
                            <p>本服务条款适用于所有访问、浏览、注册、使用本站服务、购买本站产品、订阅会员及参与本站技术活动的用户（个人、企业、机构）。用户进入、使用本站即代表自愿阅读、理解并无条件同意本《服务条款》全部内容。若用户不接受本条款，应立即停止使用本站全部服务。本协议为平台与用户之间的有效法律协议，替代双方所有口头、非正式沟通约定。</p>
                        </div>
                        <div class="legal-section">
                            <h3>2. 网站服务内容与使用规则</h3>
                            <p>iSafeClub 为 Web3 行业提供网络安全技术服务，包括但不限于：Web3 安全技术资讯发布、安全研究报告公开、智能合约安全审计、漏洞检测、链上安全监控、SaaS 安全工具服务、安全软硬件产品销售、技术论坛、线上研讨会、会员技术服务、行业标准研究等。</p>
                            <p>用户使用本站服务应遵守以下规则：</p>
                            <ul>
                                <li>不得利用本网站从事非法金融、黑客攻击、入侵、漏洞滥用、网络攻击、侵犯他人权益等违法违规行为；</li>
                                <li>不得恶意爬取、批量攻击、干扰网站正常运行、破坏平台技术安全体系；</li>
                                <li>用户在论坛、社群、留言区发布内容不得包含违法、侵权、谣言、恶意攻击、违规金融宣传等内容；</li>
                                <li>用户需保证自身注册信息、企业信息真实、合法、有效。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>3. 用户权利与义务</h3>
                            <p class="legal-subtitle">3.1 用户权利</p>
                            <ul>
                                <li>合法、合规、依规浏览网站公开内容、查阅行业安全资讯、公开技术报告；</li>
                                <li>注册账号并根据会员等级享受对应工具、课程、技术咨询、社群服务权益；</li>
                                <li>购买付费服务后，有权要求我方按照公示服务标准交付对应产品与服务；</li>
                                <li>有权查询、更正本人账号相关资料、申请注销账号；</li>
                                <li>有权知晓平台数据收集、使用、存储规则。</li>
                            </ul>
                            <p class="legal-subtitle">3.2 用户义务</p>
                            <ul>
                                <li>对自身账号、登录权限、设备安全承担全部责任；</li>
                                <li>不得转借、售卖、共享企业付费会员账号给非授权第三方；</li>
                                <li>使用我方安全工具、审计服务、硬件设备不得用于非法网络攻击行为；</li>
                                <li>遵守所在地区法律法规及本平台管理规范。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>4. 付费服务、订阅与交易规则</h3>
                            <p>本站提供以下商业化付费服务，所有收费标准以官网 Pricing 公示价格为准：定制化 Web3 安全项目服务、SaaS 软件订阅服务、安全软硬件产品销售、年度会员订阅服务。</p>
                            <ul>
                                <li>所有付费服务一经下单，视为用户认可对应服务内容、价格、交付周期；</li>
                                <li>月度 / 年度订阅服务到期自动终止，用户可自主续费；</li>
                                <li>定制化项目服务启动、人员排期、代码审计启动后，非我方原因不支持退款；</li>
                                <li>已交付报告、技术成果、软件授权、硬件产品不支持无理由退换；</li>
                                <li>平台有权根据市场调整定价，调价将提前于官网公示，不影响已购未到期服务。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>5. 知识产权条款</h3>
                            <p>网站所有文字、图片、代码工具、脚本、安全报告、白皮书、专利内容、课程内容、技术文档，知识产权均归 Isafeclub LIMITED 所有。未经我方书面授权，任何单位及个人不得复制、转载、篡改、商用、二次分发。</p>
                            <p>用户提交、发布在平台的内容，默认授予平台展示、归档、研究使用权限，用户对自有内容承担全部法律责任。</p>
                        </div>
                        <div class="legal-section">
                            <h3>6. 第三方服务与外部链接说明</h3>
                            <p>本站页面可能包含第三方网站链接、第三方社交工具入口（Twitter、Telegram 社群等）、第三方链上数据工具、第三方支付合作渠道。用户跳转至第三方平台所产生的一切行为、交易、风险、数据授权，均由第三方平台负责，我方不对第三方服务的合规性、安全性、稳定性承担连带责任。本站第三方入口仅为用户便利，不代表我方对第三方机构的背书与担保。</p>
                        </div>
                        <div class="legal-section">
                            <h3>7. 责任限制与风险免责</h3>
                            <p>用户明确知晓 Web3、区块链、智能合约行业存在固有技术风险、链上风险、黑客攻击风险、市场风险、合规风险。</p>
                            <ul>
                                <li>我方提供的安全审计、漏洞检测、监控工具仅为技术安全辅助手段，不保证绝对零风险、绝对无漏洞，不直接等同于项目资产保本、无损失承诺；</li>
                                <li>因用户自身代码更新、私自修改合约、私自授权、私钥泄露、第三方平台漏洞导致的损失，我方不承担赔偿责任；</li>
                                <li>对于不可抗力、网络瘫痪、监管政策变动、第三方攻击导致的服务中断、数据延迟，我方不承担违约责任；</li>
                                <li>我方最大赔偿责任不超过用户当期对应服务的实际支付金额。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>8. 服务暂停、终止与账号封禁</h3>
                            <p>如用户存在违规使用、恶意攻击、盗用权限、违法经营、侵权行为，我方有权不经通知限制、暂停、终止用户账号权限及对应服务，且不予以退款。</p>
                        </div>
                        <div class="legal-section">
                            <h3>9. 条款更新与公示机制</h3>
                            <p>我方保留随时更新本服务条款的权利，修订后将在官网底部法律板块公示，公示后立即生效，用户持续使用网站即视为接受更新后条款。</p>
                        </div>
                        <div class="legal-section">
                            <h3>10. 适用法律与争议解决</h3>
                            <p>本网站及全部服务由 Isafeclub LIMITED 运营，本协议适用新加坡共和国商事法律管辖。双方发生争议优先友好协商，协商不成提交新加坡商事争议调解机构处理。</p>
                        </div>
                    </div>

                    <!-- 隐私政策 -->
                    <div v-else>
                        <div class="legal-section">
                            <h3>1. 政策概述与运营主体</h3>
                            <p>本隐私政策由 Isafeclub LIMITED 制定并执行，适用于官网 https://isafeclub.org 全部用户数据收集、存储、使用、传输与保护规则。本政策旨在向用户清晰说明我方如何收集、使用、保管用户信息，用户享有何种数据权利，完全符合国际网站合规、新加坡数据合规及全球通用网站隐私披露标准。</p>
                        </div>
                        <div class="legal-section">
                            <h3>2. 收集的用户信息范围</h3>
                            <p>我方仅收集开展业务必要的合法信息，包括：</p>
                            <ul>
                                <li>基础访问信息：访问 IP、设备类型、浏览器信息、访问页面、访问时间、停留时长；</li>
                                <li>注册账号信息：用户名、邮箱、联系电话、企业名称、企业联系人信息；</li>
                                <li>业务服务信息：用户提交的项目资料、安全审计需求、工具使用记录、服务沟通记录；</li>
                                <li>交易信息：付费订单记录、订阅记录、软硬件采购记录、开票信息。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>3. Cookies 与本地存储技术说明</h3>
                            <p>本网站使用 Cookies、本地缓存、网页存储技术用于提升用户访问体验、保存用户登录状态、记录用户浏览偏好、优化网站功能稳定性。</p>
                            <ul>
                                <li>本站 Cookie 仅用于本站功能运行，不用于第三方恶意追踪；</li>
                                <li>用户可通过浏览器设置自主拒绝、清除 Cookie；</li>
                                <li>关闭 Cookie 不会影响网站基础浏览功能，但可能导致登录状态、个性化功能失效。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>4. 数据使用目的</h3>
                            <p>我方收集的所有用户信息仅用于以下合法用途：</p>
                            <ul>
                                <li>维护网站正常运行、保障账号安全；</li>
                                <li>为用户提供安全审计、SaaS 工具、会员服务、技术咨询等对应服务；</li>
                                <li>处理订单、订阅、售后、技术支持；</li>
                                <li>推送行业安全资讯、漏洞预警、平台活动通知；</li>
                                <li>合规留存业务记录，满足企业经营、审计、合规核查要求。</li>
                            </ul>
                        </div>
                        <div class="legal-section">
                            <h3>5. 数据共享与第三方服务规则</h3>
                            <p>我方不会向无关联第三方出售、交易、出租用户个人及企业数据。仅在以下情形可依法提供：</p>
                            <ul>
                                <li>用户主动授权、书面同意；</li>
                                <li>法律法规、监管机构、司法机关依法定程序调取；</li>
                                <li>平台合作技术服务商（仅用于支撑本站服务运行，且签署数据保密协议）。</li>
                            </ul>
                            <p>第三方社交平台、支付工具、链上工具的数据处理，由对应第三方隐私政策约束。</p>
                        </div>
                        <div class="legal-section">
                            <h3>6. 数据存储、安全保护与跨境传输说明</h3>
                            <p>用户数据存储于合规安全服务器，采取加密存储、访问权限隔离、日志审计、安全防护机制，防止数据泄露、篡改、丢失。</p>
                            <p>因我方为全球化运营机构（新加坡、苏黎世、纽约办公室），用户数据可能在合规前提下进行跨境存储与处理，我方严格遵守跨境数据合规要求，保障用户数据安全等级不低于属地标准。</p>
                        </div>
                        <div class="legal-section">
                            <h3>7. 用户数据权利</h3>
                            <p>用户享有对个人及企业信息的查阅、更正、删除、注销、撤回授权的权利，如需申请可通过官方邮箱 service@isafeclub.org 提交申请，我方将在合规时限内处理。</p>
                        </div>
                        <div class="legal-section">
                            <h3>8. 未成年人保护</h3>
                            <p>本站服务面向行业从业者、企业机构、成年开发者，不面向未成年人提供服务，若发现未成年人使用，我方将主动清除对应数据并终止服务。</p>
                        </div>
                        <div class="legal-section">
                            <h3>9. 隐私政策更新</h3>
                            <p>我方可根据业务升级、合规要求更新本隐私政策，更新后将在官网公开公示，公示后即时生效。</p>
                        </div>
                        <div class="legal-section">
                            <h3>10. 联系我们</h3>
                            <p>如对本服务条款、隐私政策及数据安全有任何疑问，可通过官方联系方式咨询：</p>
                            <p>邮箱：service@isafeclub.org</p>
                            <p>运营主体：Isafeclub LIMITED</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Legal Modal -->
    </div>
</template>

<script>
    import Copyright from './Copyright'
    import Button from '../../elements/button/Button'
    import Icon from '../../icon/Icon'
    import ScrollTop from './ScrollTop'
    import Logo from '../../elements/logo/Logo'
    import Newsletter from './Newsletter'

    export default {
        name: 'Footer',
        components: {Newsletter, Logo, ScrollTop, Icon, Button, Copyright},
        props: {
            data: {
                default: null
            }
        },
        data() {
            return {
                activeModal: null
            }
        },
        methods: {
            openModal(type) {
                this.activeModal = type;
                document.body.style.overflow = 'hidden';
            },
            closeModal() {
                this.activeModal = null;
                document.body.style.overflow = '';
            }
        }
    }
</script>
<style lang="scss">
.foot-up {
	padding: 40px 0;
	background-color: #070a2b;
	.foot-up-wrap {
		display: flex;
		align-items: center;
		.foot-contact {
			width: 100%;
			h2 {
				font-size: 18px;
				padding-bottom: 16px;
				margin-bottom: 20px;
				color: white;
				position: relative;
				&:after {
					content: "";
					position: absolute;
					bottom: 0;
					left: 0;
					width: 50px;
					height: 3px;
					background-color: #fff;
				}
			}
			.contact-items {
				display: flex;
				justify-content: space-between;
				width: 100%;
			}
			.contact-item {
				color: #b6b7b7;
				.contact-item-title {
					font-weight: 400;
					font-size: 20px;
				}
				.contact-item-content {
					margin-top: 12px;
					font-size: 14px;
					display: flex;
					gap: 20px;
					p {
						color: #b6b7b7;
					}
				}
			}
		}
	}
}
.foot-legal {
	padding: 30px 0;
	.foot-legal-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 30px;
	}
	.legal-statement {
		flex: 1;
		h3 {
			font-size: 16px;
			color: #fff;
			margin-bottom: 10px;
		}
		p {
			font-size: 13px;
			color: #8f91a8;
			line-height: 1.8;
			margin-bottom: 0;
		}
	}
	.legal-links {
		flex-shrink: 0;
		display: flex;
		align-items: center;
		gap: 10px;
		a {
			color: #b6b7b7;
			font-size: 14px;
			transition: .3s;
			&:hover {
				color: #0d6efd;
			}
		}
		.divider {
			color: #444;
		}
	}
}
.legal-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .6);
	z-index: 9999;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	.legal-modal-inner {
		background: #fff;
		width: 100%;
		max-width: 760px;
		max-height: 80vh;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: legalModalIn .3s ease;
	}
	.legal-modal-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px 30px;
		background: #070a2b;
		h2 {
			font-size: 22px;
			color: #fff;
			margin: 0;
		}
		.legal-modal-close {
			background: none;
			border: none;
			color: #fff;
			cursor: pointer;
			display: flex;
			padding: 0;
		}
	}
	.legal-modal-body {
		padding: 30px;
		overflow-y: auto;
		.legal-section {
			margin-bottom: 26px;
			&:last-child {
				margin-bottom: 0;
			}
			h3 {
				font-size: 17px;
				font-weight: 700;
				color: #1a1a1a;
				margin-bottom: 12px;
				padding-left: 12px;
				position: relative;
				&:after {
					content: "";
					position: absolute;
					height: 70%;
					width: 4px;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					background-color: #0d6efd;
				}
			}
			p {
				font-size: 14px;
				color: #4d4d4d;
				line-height: 1.9;
				margin-bottom: 10px;
				text-align: justify;
				&.legal-subtitle {
					font-weight: 700;
					color: #0d6efd;
					margin: 14px 0 8px;
				}
			}
		}
		ul {
			padding-left: 0;
			margin: 0 0 10px;
			li {
				font-size: 14px;
				color: #4d4d4d;
				line-height: 1.8;
				padding: 6px 0 6px 22px;
				position: relative;
				text-align: justify;
				&:before {
					content: "";
					position: absolute;
					left: 2px;
					top: 15px;
					width: 7px;
					height: 7px;
					border-radius: 50%;
					background-color: #0d6efd;
				}
			}
		}
	}
}
@keyframes legalModalIn {
	from { opacity: 0; transform: translateY(30px); }
	to { opacity: 1; transform: translateY(0); }
}
@media screen and (max-width: 850px) {
	.foot-up .foot-up-wrap .foot-contact .contact-items,
	.foot-up .foot-up-wrap .foot-contact .contact-item .contact-item-content{
		flex-direction: column;
	}
	p {
		margin-bottom: 0 !important;
	}
	.contact-item:last-child {
		margin-top: 20px;
	}
	.foot-legal .foot-legal-wrap {
		flex-direction: column;
		align-items: flex-start;
	}
}
</style>
